export const mappedArray = (array, keyGetter, valueGetter) => {
  const map = {};
  array.forEach((item) => {
    map[keyGetter?.(item) ?? item?.id] = valueGetter?.(item) ?? item;
  }, {});

  return map;
};
